export default __webpack_public_path__ + "static/media/short.670d98eb.svg";